import { ResponseError } from "@apis/backend";

export async function handleHttpError(e: unknown): Promise<string> {
  let abortError: Error | null = null;
  if (e instanceof Error) {
    if (e.cause instanceof Error && e.cause.name === "AbortError") {
      abortError = e.cause;
    } else if (e.name === "AbortError") {
      abortError = e;
    }
  }

  if (abortError) {
    // The request was aborted for some reason, so we do not care about that here.
    // One reason might be using the AbortController but also like reloading the page.
    return Promise.reject(abortError.name + ": " + abortError.message);
  }
  const response = getResponse(e);
  if (response) {
    const body = await response.text();
    console.error(e);
    console.error("Body: " + body);

    return new Promise((resolve) =>
      resolve(
        `URL: ${response.url}\nStatus: ${response.status}${
          body ? `\nBody: ${body}` : ``
        }`,
      ),
    );
  } else {
    console.error(e);
    if (e instanceof Error) {
      console.error(e.cause);
    }
    return new Promise((resolve) => resolve(String(e)));
  }
}

function getResponse(e: unknown): Response | undefined {
  if (e instanceof ResponseError) {
    return e.response;
  } else {
    return undefined;
  }
}
